// extracted by mini-css-extract-plugin
module.exports = {"pagination-current":"SwiperLayout_pagination-current__Ub_3h"};